import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',_vm._l((_vm.messages),function(message,i){return _c(VRow,{key:i,staticClass:"mx-4 mt-2",attrs:{"value":i}},[_c('p',{staticClass:"body-2 memberid-red--text font-weight-bold"},[_vm._v("・"+_vm._s(message))])])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }